import { createFileRoute } from "@tanstack/react-router";
import { OrganizationOverviewPage } from "@/pages/organization-overview/ui/organization-overview-page";
import { preloadOrganizationOverviewQueries } from "@/pages/organization-overview/api/preload-organization-overview-queries";
import { searchParams } from "@/pages/organization-overview/model/search-params";

export const Route = createFileRoute("/_authed/$companySlug/organisations/")({
  component: OrganizationOverviewPage,
  loader: ({ context }) => {
    // company is guaranteed by $companySlug beforeLoad redirect guard
    if (context.company) {
      void preloadOrganizationOverviewQueries(context.company.id);
    }
  },
  validateSearch: searchParams,
});
